@if (isVisible()) {
<button type="button" class="scroll-to-top-button" (click)="scrollToTop()" aria-label="ページ最上部へ戻る">
  <img src="/float-button/float-button.svg" alt="" aria-hidden="true" class="scroll-to-top-icon" />
</button>
}
